import React from "react";

export function Header({ user }) {
  const firstLetter = user?.name?.slice(0, 1) || "";
  const lastLetter = user?.lastname?.slice(0, 1) || "";

  const displayName =
    user?.username ||
    `${user?.name || ""} ${user?.lastname || ""}`.trim();

  return (
    <header className="header modern-header">

      <div className="modern-header-title">
        <span>Proceso Seguro</span>
        <strong>Plataforma de capacitación</strong>
      </div>

      <div className="modern-user-card">

        <div className="modern-user-avatar">
          {user?.avatar ? (
            <img
              src={user.avatar}
              alt="Perfil"
            />
          ) : (
            <span>
              {firstLetter}
              {lastLetter}
            </span>
          )}
        </div>

        <div className="modern-user-info">
          <strong>{displayName}</strong>
          <span>Cuenta activa</span>
        </div>

      </div>

    </header>
  );
}